






























































import { FindImportacaoUseCase } from '@/usecases'
import type { UsuarioServiceAdapter } from '@/usecases'
import { Component, Vue } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'

@Component
export default class DialogoDeCsvUsuarios extends Vue {
	@Inject('UsuarioServiceAdapter')
	private usuarioService!: UsuarioServiceAdapter

	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
	]
	importando = false
	arquivoContemCabecalho = false
	arquivoCsv: File[] = []
	findImportacaoUseCase = new FindImportacaoUseCase()

	async mostrar() {
		this.mostra = true
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = []
		this.arquivoContemCabecalho = false
	}

	get permiteAbrirDiversosProcessosDeImportacao() {
		if (!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	async concluirImportacao() {
		if (this.arquivoCsv.length == 0) {
			return AlertModule.setError('É obrigatório selecionar um arquivo')
		}

		if (!this.usuario) return

		if (!this.permiteAbrirDiversosProcessosDeImportacao) {
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario)

			if (!possuiProcessoEmAberto) {
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!')
				this.importando = false
				return
			}
		}

		try {
			this.importando = true

			const informacoesDosArquivos = await uploadFilesToS3(
				this.arquivoCsv,
				`importacao-de-usuarios`,
			)
			const urlDoArquivoCsv = informacoesDosArquivos.map(({ config }) => config.url)[0]

			if (!urlDoArquivoCsv) {
				return AlertModule.setError('Ocorreu um erro interno, contate o suporte')
			}

			await this.usuarioService.importaUsuarios(
				urlDoArquivoCsv,
				this.arquivoContemCabecalho,
			)

			AlertModule.setSuccess('Itens em processamento')
			this.arquivoCsv = []
			this.mostra = false
			this.arquivoContemCabecalho = false
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.importando = false
		}
	}

	async baixarModelo() {
		const rows = [
			[
				'nome', 'cpf', 'perfil', 'login', 'senha', 'codigo_externo', 'vendedor', 'representante', 'telefone', 'loja', 'grupo_economico',
			],
		]

		const csvContent = 'data:text/csv;charset=utf-8,'
			+ rows.map(e => e.join(';')).join('\n')

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement('a')
		link.setAttribute('href', encodedUri)
		link.setAttribute('download', 'modelo_importacao_usuario.csv')
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}
}
